// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';

const MaintenancePlanPinCriteria = props =>
    <div className='maintenance-plan-pin-criteria'>
        <LabeledCriteria
            className='pin-criteria'
            isRequired={false}
            label='PIN'
            maxLength='17'
            onInputChange={props.onHandlePinInputChange}
            placeholder='PIN'
            type='text'
            value={props.pin}
        />
    </div>;

MaintenancePlanPinCriteria.displayName = 'MaintenancePlanPinCriteria';
MaintenancePlanPinCriteria.propTypes = {
    onHandlePinInputChange: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired
};

export default MaintenancePlanPinCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-pin-criteria.js